import Redux from 'redux';
import * as Bixby from '$/core';
import {
  CloState,
  CLO_FAILURE,
  CLO_LOADING,
  CLO_SUCCESS,
  CloActionTypes,
  HEATMAP_OFF,
  HEATMAP_ON,
  ALL_CLO_SUCCESS,
  CREATE_CLO,
  ADD_CLIENT_CLO,
  ADD_CLIENT_CLO_SUCCESS,
  ADD_CLIENT_CLO_FAILURE,
  DELETE_CLIENT_CLO,
  DELETE_CLIENT_CLO_SUCCESS,
  DELETE_CLIENT_CLO_FAILURE,
} from './types';

const initialState: CloState = {
  isLoading: false,
  error: undefined,
  currentClo: undefined,
  heatMapActive: true,
  clos: undefined,
  isAddingCloToClient: false,
};

const cloReducer: Redux.Reducer<CloState> = (state = initialState, action: CloActionTypes): CloState => {
  switch (action.type) {
    case CLO_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case CLO_SUCCESS:
      const cloPayload = action.payload as Bixby.Models.Clo;
      return {
        ...state,
        isLoading: false,
        currentClo: cloPayload,
        error: undefined,
      };
    case CLO_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        currentClo: undefined,
      };
    case HEATMAP_OFF:
      return {
        ...state,
        heatMapActive: action.payload as boolean,
      };
    case HEATMAP_ON:
      return {
        ...state,
        heatMapActive: action.payload as boolean,
      };
    case ALL_CLO_SUCCESS:
      const allCloPayload = action.payload as Bixby.Models.CloSlim[];
      return {
        ...state,
        isLoading: false,
        clos: allCloPayload,
        currentClo: undefined,
        error: undefined,
      };
    case CREATE_CLO:
      const createCloPayload = action.payload as Bixby.Models.Clo;
      return {
        ...state,
        isLoading: false,
        currentClo: createCloPayload,
        error: undefined,
      };
    case ADD_CLIENT_CLO:
      return {
        ...state,
        isAddingCloToClient: true,
      };
    case ADD_CLIENT_CLO_SUCCESS:
      return {
        ...state,
        isAddingCloToClient: false,
      };
    case ADD_CLIENT_CLO_FAILURE:
      return {
        ...state,
        isAddingCloToClient: false,
      };
    case DELETE_CLIENT_CLO:
      return {
        ...state,
        isDeletingCloFromClient: true
      };
    case DELETE_CLIENT_CLO_SUCCESS:
      return {
        ...state,
        isDeletingCloFromClient: false
      };
    case DELETE_CLIENT_CLO_FAILURE:
      return {
        ...state,
        isDeletingCloFromClient: false,
        deletingCloFromClientError: (action.payload || {}) as Bixby.Models.BixbyError,
      };

    default:
      return state;
  }
};

export default cloReducer;
